import { Grid, Typography } from '@mui/material'
import { ChargeRate } from 'api/vehicle/taxisRatesAPI.types'
import FormInput from 'components/FormFields/FormInput/FormInput'
import styles from 'components/Supplier/Manage/manageSupplierStyle'
import React, { Dispatch } from 'react'

interface Props {
  waitingTime: string
  chargeOverrideId?: string
  chargeRates: Array<ChargeRate>
  setChargeRates: Dispatch<React.SetStateAction<Array<ChargeRate>>>
  isEdit: boolean
  additionalStop: boolean
  waitAndReturn: boolean
}

const RoutePricingGridTitles = (props: Props) => {
  const { waitingTime, chargeRates, isEdit, additionalStop, waitAndReturn } =
    props
  return (
    <Grid container item spacing={2} direction="row" alignItems="flex-end">
      <Grid item xs={2}></Grid>
      {/* <Grid item xs={1}></Grid>
      <Grid item xs={1}></Grid> */}
      <Grid item xs={1}>
        <Typography>Minimum Fare</Typography>
      </Grid>

      {waitingTime === 'grace' && (
        <Grid item xs={1}>
          <Typography>Grace period charge</Typography>
        </Grid>
      )}
      {waitingTime !== '' && (
        <Grid item xs={1}>
          <Typography>Waiting time charge per unit</Typography>
        </Grid>
      )}
      {waitAndReturn && (
        <Grid item xs={1}>
          <Typography>Wait and return charge time</Typography>
        </Grid>
      )}
      {additionalStop && (
        <Grid item xs={1}>
          <Typography>Additional stop charge</Typography>
        </Grid>
      )}

      {chargeRates.map((item, i) => {
        return (
          <Grid item key={item.id} xs={1}>
            <FormInput
              name={`chargeRates[${i}].fromMile`}
              label="From"
              sx={styles.inputField}
              disabled={!isEdit}
              defaultValue={chargeRates[i].fromMile}
              fullWidth
            />
            <FormInput
              name={`chargeRates[${i}].toMile`}
              label="To"
              sx={styles.inputField}
              disabled={!isEdit}
              defaultValue={chargeRates[i].toMile}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
export default RoutePricingGridTitles
